module.exports = __webpack_public_path__ + "img/megabot.03202feb.svg";